var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelefone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0375 16.25V15.125H12.625V14.1125H9.85V8.56245H12.625V7.28745C12.625 5.73745 12.0813 4.40308 10.9938 3.28433C9.90625 2.16558 8.5875 1.6062 7.0375 1.6062C5.4875 1.6062 4.15625 2.16558 3.04375 3.28433C1.93125 4.40308 1.375 5.73745 1.375 7.28745V8.56245H4.15V14.1125H1.375C1.075 14.1125 0.8125 14 0.5875 13.775C0.3625 13.55 0.25 13.2875 0.25 12.9875V7.28745C0.25 6.34995 0.428125 5.4687 0.784375 4.6437C1.14063 3.8187 1.625 3.09683 2.2375 2.47808C2.85 1.85933 3.56875 1.37183 4.39375 1.01558C5.21875 0.659326 6.1 0.481201 7.0375 0.481201C7.975 0.481201 8.85312 0.659326 9.67188 1.01558C10.4906 1.37183 11.2 1.85933 11.8 2.47808C12.4 3.09683 12.875 3.8187 13.225 4.6437C13.575 5.4687 13.75 6.34995 13.75 7.28745V15.125C13.75 15.425 13.6375 15.6875 13.4125 15.9125C13.1875 16.1375 12.925 16.25 12.625 16.25H7.0375ZM1.375 12.9875H3.025V9.68745H1.375V12.9875ZM10.975 12.9875H12.625V9.68745H10.975V12.9875ZM12.625 12.9875H10.975H12.625ZM3.025 12.9875H1.375H3.025Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone.9b5f03a80d36b817ff262eee87cf8336.svg";
export { ForwardRef as ReactComponent };